import { Clock } from 'lucide-react'
import type { Donation } from '@/features/donations/types/donation'
import { Badge } from '@/components/custom/badge'
import { ScrollArea, ScrollBar } from '@/components/ui/scroll-area'
import { DonationCard } from '@/features/donations/components/DonationCard'
import { useIsMobile } from '@/hooks'

type CashNotDepositProps = {
  donations: Array<Donation>
  donorNameResolver: (donorId: string | null) => string
}

export function CashNotDeposit({
  donations,
  donorNameResolver,
}: CashNotDepositProps) {
  const isMobile = useIsMobile()

  if (!isMobile) {
    return (
      <div className="bg-white rounded-lg border">
        <div className="px-6 py-4 border-b border-gray-200">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <Clock className="h-5 w-5 text-yellow-600 mr-2" />
              <h2 className="text-lg font-medium text-gray-900">
                Cash Not Deposited
              </h2>
            </div>
            <Badge color="yellow">{donations.length} not deposited</Badge>
          </div>
        </div>
        <div className="p-6">
          {donations.length === 0 ? (
            <div className="text-center py-8">
              <p className="text-gray-500">No cash pending deposit</p>
            </div>
          ) : (
            <ScrollArea className="w-full overflow-x-auto">
              <div className="inline-flex gap-4 w-[75vw]">
                {donations.map((donation) => (
                  <DonationCard
                    key={donation._id}
                    donation={donation}
                    type="notDeposited"
                    donorName={donorNameResolver(donation.donorId)}
                  />
                ))}
              </div>
              <ScrollBar orientation="horizontal" />
            </ScrollArea>
          )}
        </div>
      </div>
    )
  }

  return donations.length === 0 ? (
    <div className="text-center py-8">
      <p className="text-gray-500">No cash pending deposit</p>
    </div>
  ) : (
    <ScrollArea className="flex-1">
      <div className="space-y-3">
        {donations.map((donation) => (
          <DonationCard
            key={donation._id}
            donation={donation}
            type="notDeposited"
            donorName={donorNameResolver(donation.donorId)}
          />
        ))}
      </div>
    </ScrollArea>
  )
}
